module.exports = __webpack_public_path__ + "img/icon-category-trailer-bg.11a0bae6.jpg";